export default __webpack_public_path__ + "static/media/upload-folder_purple.e8f03781.svg";